export default "__VITE_ASSET__DUyUDHtP__"